import { APIClient } from '../../helpers/api_helper';

const api = new APIClient();

export class BlogService {
  async getAllBlogs(params?: any) {
    return api.get('/api/v1/blogs/admin/list', params);
  }
  async getBlogDetails(id: string) {
    return api.get(`/api/v1/blogs/admin/details/${id}`, undefined);
  }
  async addBlog(data: any) {
    return api.create('/api/v1/blogs/admin/add', data);
  }
  async updateBlog(id: string, data: any) {
    return api.create(`/api/v1/blogs/admin/edit/${id}`, data);
  }
  async deleteBlog(id: string) {
    return api.create(`/api/v1/blogs/admin/delete/${id}`, {});
  }
}

export const blogService = new BlogService(); 